import React from "react";
import { Container } from "reactstrap";
import { useLocation } from "react-router-dom";
import { PageHeader } from "@/CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useSystem } from "@/utils/hooks/useLocation";
import { HousingInspectionOrderForm } from "./HousingInspectionOrderForm";
import { useHousingInspectionContext } from "./HousingInspectionContext/housingContext";
import { EXAMINATION_TYPES } from "@/utils/constants";

export const CreateHousingInspection = () => {
  // =============
  // Hooks
  // =============
  const { t } = useTranslation();
  const { state: locationState } = useLocation();
  const { currentSystem } = useSystem();
  const {
    inspectionState: { type },
  } = useHousingInspectionContext();

  const fromBuildingsNotInspected =
    locationState?.fromBuildingsNotInspected === true;
  const backTo = fromBuildingsNotInspected
    ? `/app/${currentSystem}/buildings-not-inspected`
    : undefined;

  const fromBuildingsNotInspectedState = fromBuildingsNotInspected
    ? {
        fromReportId: locationState?.fromReportId,
        contractId: locationState?.contractId,
        houseComrRegNo: locationState?.houseComrRegNo,
      }
    : undefined;

  const isTrack = type === EXAMINATION_TYPES.track;
  return (
    <div>
      <PageHeader
        title={
          isTrack ? t("CREATE_TRACK_ORDER") : t("CREATE_HOUSING_INSPECTION")
        }
        backTo={backTo}
        sticky={false}
      />
      <Container fluid>
        <HousingInspectionOrderForm
          fromBuildingsNotInspectedState={fromBuildingsNotInspectedState}
        />
      </Container>
    </div>
  );
};
